module.exports = __webpack_public_path__ + "img/health.8371f582.png";